import localData from './api/localData'
import standard from './api/standard'

const CONTACT_API = {
  ...localData,
  ...standard
}

export default CONTACT_API
